import util from '@/libs/util'

// 角色列表
export function roleList(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/common/role/list',
    params
  })
}

// 角色分页
export function rolePage(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/role/page',
    params
  })
}

// 新增角色
export function roleAdd(data) {
  return util.http({
    method: 'post',
    url: 'system/auth/role',
    data
  })
}

// 角色信息
export function roleDetail(id) {
  return util.http({
    method: 'get',
    url: `system/auth/role/${id}`
  })
}

// 修改角色
export function roleEdit(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/role',
    data
  })
}

// 删除角色
export function roleDelete(id) {
  return util.http({
    method: 'delete',
    url: `system/auth/role?roleId=${id}`
  })
}

// 锁定/解锁角色
export function roleLock(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/role/lock',
    data
  })
}

// 角色菜单列表
export function roleMenuList(id) {
  return util.http({
    method: 'get',
    url: `system/auth/menu/roleMenu/${id}`
  })
}

// 修改角色菜单
export function roleMenuEdit(data) {
  return util.http({
    method: 'post',
    url: 'system/auth/menu/roleMenu',
    data
  })
}

// 用户账号分页
export function adminPage(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/admin/page',
    params
  })
}

// 新增用户账号
export function adminAdd(id, data) {
  return util.http({
    method: 'post',
    url: `system/auth/admin?roleIds=${id}`,
    data
  })
}

// 用户账号信息
export function adminDetail(id) {
  return util.http({
    method: 'get',
    url: `system/auth/admin/${id}`
  })
}

// 修改用户账号
export function adminEdit(data) {
  return util.http({
    method: 'put',
    url: `system/auth/admin`,
    data
  })
}

// 删除用户账号
export function adminDelete(id) {
  return util.http({
    method: 'delete',
    url: `system/auth/admin?adminId=${id}`
  })
}

// 锁定/解锁用户账号
export function adminLock(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/admin/lock',
    data
  })
}

// 用户账号重置密码
export function adminPassword(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/admin/password',
    data
  })
}

// 登录日志分页
export function loginLogPage(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/loginLog/page',
    params
  })
}

// 登录日志删除
export function loginLogDelete(id) {
  return util.http({
    method: 'delete',
    url: `system/auth/loginLog/${id}`
  })
}

// 登录日志清空
export function loginLogClean() {
  return util.http({
    method: 'delete',
    url: 'system/auth/loginLog/clean'
  })
}

// 操作日志分页
export function operLogPage(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/operLog/page',
    params
  })
}

// 操作日志删除
export function operLogDelete(id) {
  return util.http({
    method: 'delete',
    url: `system/auth/operLog/${id}`
  })
}

// 操作日志清空
export function operLogClean() {
  return util.http({
    method: 'delete',
    url: 'system/auth/operLog/clean'
  })
}

// 字典列表
export function dicList() {
  return util.http({
    method: 'get',
    url: 'system/auth/dic/list',
  })
}

// 字典分页
export function dicPage(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/dic/page',
    params
  })
}

// 新增字典
export function dicAdd(data) {
  return util.http({
    method: 'post',
    url: `system/auth/dic`,
    data
  })
}

// 字典信息
export function dicDetail(id) {
  return util.http({
    method: 'get',
    url: `system/auth/dic/${id}`
  })
}

// 修改字典
export function dicEdit(data) {
  return util.http({
    method: 'put',
    url: `system/auth/dic`,
    data
  })
}

// 锁定/解锁字典
export function dicLock(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/dic/lock',
    data
  })
}

// 行业类型字典列表
export function industryTypeList() {
  return util.http({
    method: 'get',
    url: 'system/auth/common/dic/itemList/industry'
  })
}

// 企业规模字典列表
export function companyScaleList() {
  return util.http({
    method: 'get',
    url: 'system/auth/common/dic/itemList/companyScale'
  })
}
